// extracted by mini-css-extract-plugin
module.exports = {"app__header":"D_cn","app__footer":"D_5","app__flex_row":"D_cp","app__content__list":"D_cq"};